import { useHistory } from "react-router-dom";
import { AccType, FiltersItemType, SearchOption } from "../common/filters";
import { Dispatch, SetStateAction/*, useState */ } from "react";
import { AppDispatch } from "../../redux/store";
import {
  Input,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Spinner
} from "reactstrap";
import { ChevronDown } from "react-feather";
import {
  ColumnDefinition,
  ColumnDefinitionMap,
  ColumnsProps,
  ColumnVisible
} from "../common/table/table.types";
//import classnames from "classnames";

type History = ReturnType<typeof useHistory>;

//const { userData } = useSelector((state: any) => state.auth);
//useState
//const [selectedRows, setSelectedRows] = useState([]);
//const [downloadLoading/*, setDownloadLoading*/] = useState(false);
//const [isSelectAll, setIsSelectAll] = useState(false);

export enum ColumnsEnum {
  SELECTION = "selection",
  ACTIONS = "actions",
  STATUS = "status",
  FOLIO = "folio",
  PAID_AT = "paid_at",
  SELLER = "seller",
  CLIENT = "client",
  TAX_DATA = "tax_data",
  PAYMENT_METHOD = "payment_method",
  CURRENCY = "currency",
  AMOUNT = "amount"
}

export enum RoleEnum {
  ACCOUNTANT = "accountant",
  SELLER = "seller",
  ADMIN = "admin",
  CLIENT = "client"
}

export const ColumnsDefinitions: ColumnDefinitionMap = {
  [ColumnsEnum.SELECTION]: {
    id: "selection-checkbox",
    name: (
      <div>
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="p-0" style={{ background: 'transparent', border: 'none' }}>
            <div className="d-flex flex-row gap-1">
              <div onClick={(e) => e.stopPropagation()}>
                <Input
                  type='checkbox'
                  id='checkbox-all'
                  //onChange={/*handleSelectAll*/}
                  /*checked={isSelectAll}*/ />
              </div>
              <div style={{ cursor: 'pointer' }}><ChevronDown className='text-white' /></div>
            </div>
          </DropdownToggle>
          <DropdownMenu container="body" style={{ zIndex: 9999, position: "fixed" }}>
            <DropdownItem onClick={() => console.log('Descargar xlsx')}>
              <span>Descargar xlsx</span>
            </DropdownItem>
            <DropdownItem onClick={() => console.log('Descargar pagos')}>
              <span>Descargar pagos</span>
            </DropdownItem>

            { /* Botón para descargar xlsx */}
            {/*userData.role !== RoleEnum.CLIENT && (
              <DropdownItem
                onClick={() => console.log('Descargar xlsx')}
                //onClick={() => downloadExport()}
                //disabled={downloadLoading}
                >
                {downloadLoading && (
                  <Spinner
                    className={classnames({
                      "position-relative": true,
                      "button-style": true
                    })}
                    size='sm'
                    style={{ marginRight: "8px" }}
                    type='grow'
                  />
                )}
                <span className='align-middle'>Descargar xlsx</span>
              </DropdownItem>
            )*/}
            {/**
            * Botón para descargar todos los certificados o según los seleccionados
            **/}
            {/*isSelectAll ? (
              <DropdownItem
                //onClick={() => handleDownloadAllClick()}
                onClick={() => console.log('Descargar todos los pagos')}
              >
                Descargar certificados
              </DropdownItem>
            ) : (*/
              /*userData.role !== RoleEnum.ACCOUNTANT && (
                <DropdownItem
                  //onClick={() => downloadHandler()}
                  onClick={() => console.log('Descargar pagos seleccionados')}
                  disabled={selectedRows?.length === 0 || isSelectAll}
                >
                  {`Descargar certificados (${selectedRows.length ?? 0
                    })`}
                  </DropdownItem>
              )
            )*/}

          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    ),
    sortable: false,
    //sortField: ColumnsEnum.SELECTION,
    center: true//,
    //maxWidth: "80px",
    //minWidth: "60px"
  },
  [ColumnsEnum.ACTIONS]: {
    id: "actions",
    name: "",
    sortable: false,
    center: true
  },
  [ColumnsEnum.STATUS]: {
    id: "status",
    name: "ESTATUS",
    sortable: true,
    sortField: ColumnsEnum.STATUS,
    center: true
  },
  [ColumnsEnum.FOLIO]: {
    id: "folio",
    name: "FOLIO",
    sortable: true,
    sortField: ColumnsEnum.FOLIO,
    minWidth: "100px"
  },
  [ColumnsEnum.PAID_AT]: {
    id: "paid_at",
    name: "FECHA DE PAGO",
    sortable: true,
    sortField: ColumnsEnum.PAID_AT,
    minWidth: "100px"
  },
  [ColumnsEnum.SELLER]: {
    id: "seller",
    name: "VENDEDOR",
    sortable: true,
    sortField: ColumnsEnum.SELLER,
    minWidth: "250px"
  },
  [ColumnsEnum.CLIENT]: {
    id: "client",
    name: "CLIENTE",
    sortable: true,
    sortField: ColumnsEnum.CLIENT,
    minWidth: "200px"
  },
  [ColumnsEnum.TAX_DATA]: {
    id: "tax_data",
    name: "RAZÓN SOCIAL",
    sortable: true,
    sortField: ColumnsEnum.TAX_DATA,
    minWidth: "150px"
  },
  [ColumnsEnum.PAYMENT_METHOD]: {
    id: "payment_method",
    name: "TIPO DE PAGO",
    sortable: true,
    sortField: ColumnsEnum.PAYMENT_METHOD,
    minWidth: "150px"
  },
  [ColumnsEnum.CURRENCY]: {
    id: "currency",
    name: "MONEDA",
    sortable: true,
    sortField: ColumnsEnum.CURRENCY,
    minWidth: "100px"
  },
  [ColumnsEnum.AMOUNT]: {
    id: "amount",
    name: "TOTAL NETO",
    sortable: true,
    sortField: ColumnsEnum.AMOUNT
  }
};

export enum PaymentStatus {
  CONCILIAR = "conciliar",
  COMPLETED = "completed",
  IN_PROGRESS = "in_progress",
  WITHOUT_VOUCHER = "without_voucher",
  CANCELLED = "canceled",
  CHARGE_PENDING = "charge_pending",
  EXPIRED = "expired"
}

export enum PaymentMethod {
  BANK_TRANSFER = "bank_account",
  STORE = "store",
  MANUAL = "manual",
  CARD = "card",
  PAYMENT_LINK = "payment_link"
}

export enum Currency {
  USD = "USD",
  MXN = "MXN"
}

export interface Certificate {
  id: number;
}

export interface CurrencyData {
  id: number;
  cfdi_value: string;
}

export interface Invoice {
  id: number;
  created_at: string;
  orbe_folio: string;
  certs: Certificate[];
  currency: CurrencyData;
  subtotal: string;
  iva: string;
  total: string;
  folio_rep: string;
  client: any;
  recipient: TaxData;
  uncollectible_at?: string | null;
  uncollectible_block: boolean;
}

export interface Receipt {
  id: number;
}

export interface User {
  id: number;
  full_name: string;
  email: string;
  name?: string;
  last_name?: string;
  last_name_2?: string;
}

export interface Client {
  id: number;
  user: User;
}

export interface Manager {
  email: string;
  document_type: string;
}

export interface TaxData {
  id: number;
  email: string;
  client: Client;
  suggestion: string;
  managers: Manager[];
  taxid?: string;
  address: string;
  street: string;
  suburb: string;
  location: string;
  city: {
    id: number;
    label: string;
  };
  state: {
    id: number;
    label: string;
  };
  country: {
    id: number;
    label: string;
  };
  postal_code: string;
  uso_cfdi: {
    id: number;
    label: string;
  };
}

export interface Seller {
  id: number;
  full_name: string;
}

export interface Payment {
  id: number;
  orbe_folio?: string;
  invoices: Invoice[];
  receipt?: Receipt | null;
  status: PaymentStatus;
  method: PaymentMethod;
  due_date: string;
  currency: Currency;
  iva: number;
  subtotal: number;
  total: number;
  concept: string;
  creation_date: string;
  agreement: string;
  bank_name: string;
  bank: string;
  clabe: string;
  reference: string;
  tax_data: TaxData;
  deleted_at: string | null;
  deleted_by: any;
  paid_at: string | null;
  seller: Seller;
  vouchers: any[];
  product_id: number;
}

export interface PaginationData {
  current_page: number;
  from: number;
  last_page: number;
  per_page: number;
  to: number;
  total: number;
}

export interface usePaymentsTableConfigReturn {
  data: {
    columns: ColumnDefinition[];
    columnsEnabled: ColumnVisible;
    columnsToOmit: ColumnVisible;
    error: string | null;
    filters: FiltersItemType[];
    searchOptions: SearchOption[];
  };
  hooks: {
    setColumnsToOmit: Dispatch<SetStateAction<ColumnVisible>>;
  };
}

export interface GetBusinessNameProps {
  businessName: string;
  maxLength: number;
  rowId: number;
}

export interface GetActionsProps {
  payment: Payment;
  role: RoleEnum;
  dispatch: AppDispatch;
  history: History;
}

export interface ActionsHandlerProps {
  payment: Payment;
  actionType: ActionTypes;
  dispatch: AppDispatch;
  history: History;
}

export interface usePaymentsTableConfigProps {
  columnsConfig?: ColumnDefinition[];
  columnsConfigFunction?: (props: ColumnsProps) => ColumnDefinition[];
  dispatch: AppDispatch;
  filtersConfig?: FiltersItemType[];
  history: History;
  searchOptionsConfig?: SearchOption[];
}

export enum ActionTypes {
  CONCILIATE = "CONCILIATE",
  VIEW_DETAILS = "VIEW_DETAILS",
  DOWNLOAD_REFERENCE = "DOWNLOAD_REFERENCE",
  VIEW_INVOICES = "VIEW_INVOICES",
  UPLOAD_VOUCHER = "UPLOAD_VOUCHER",
  DOWNLOAD_DOCUMENTS = "DOWNLOAD_DOCUMENTS",
  SEND_BY_EMAIL = "SEND_BY_EMAIL",
  CANCEL_PAYMENT = "CANCEL_PAYMENT",
  CONFIRM_CANCEL_PAYMENT = "CONFIRM_CANCEL_PAYMENT",
  DOWNLOAD_PAYMENTS = "DOWNLOAD_PAYMENTS",
  DOWNLOAD_ALL_PAYMENTS = "DOWNLOAD_ALL_PAYMENTS",
  DOWNLOAD_REPORT = "DOWNLOAD_REPORT",
  COMPLETE_PAYMENT = "COMPLETE_PAYMENT"
}

export enum DownloadExtensions {
  PDF = ".pdf",
  XLSX = ".xlsx",
  ZIP = ".zip",
}
